<template>
  <section v-if="$store.getters.isAuthenticated" class="events-page">
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-form"
      id="add-transaction"
      hide-header
      hide-footer
      dialog-class="proposed-transactions__add-transaction-modal"
      body-class="proposed-transactions__add-transaction-modal_body"
      content-class="modal_content"
      @hide="hideAddTransaction"
    >
      <add-transaction-form/>
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-footer
      hide-header
      dialog-class="move-transaction-modal"
      body-class="move-transaction-modal_body"
      content-class="modal_content"
      id="move-transaction"
    >
      <move-transaction-form />
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      hide-footer
      hide-header
      modal-class="padding-top_modal-form"
      dialog-class="events__add-event-modal"
      body-class="events__add-event-modal_body"
      content-class="modal_content"
      id="add-event"
    >
      <add-event-form/>
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-footer
      hide-header
      dialog-class="events__add-event-modal"
      body-class="events__add-event-modal_body"
      content-class="modal_content"
      id="participants"
      @show="showParticipants"
    >
      <participants-form />
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-footer
      header-class="events__add-participants-modal_header"
      dialog-class="events__add-participants-modal"
      body-class="events__add-participants-modal_body"
      content-class="modal_content"
      id="add-participants">
      <template v-slot:modal-header>
        {{ $t('CP.addParticipants') }}
      </template>
      <add-participants-form parent-modal="add-participants"/>
    </b-modal>
    <b-modal
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      header-class="events__add-participants-modal_header"
      dialog-class="events__add-participants-modal"
      content-class="modal_content"
      id="add-event-participants">
      <add-event-participants-form parent-modal="add-event-participants"/>
    </b-modal>
    <header-app
      :is-mobile="isMobile"
    />
    <page-error v-if="eventsStatus === 'error'" :showLang="false">
      <template #message>
        {{ $t('CP.errorOccurred') }}
      </template>
    </page-error>
    <main class="main" v-else>
      <router-view
        @toggleOptionsPanel="toggleOptionsPanel()"
        :show-options="showOptions"
        :is-mobile="isMobile"/>
    </main>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  CLEAR_CURRENT_EVENT, EVENT_PAYOUTS_REQUEST, FETCH_EVENT_EXPENSES_REQUEST,
  FETCH_EVENT_REQUEST, FETCH_EVENT_SUCCESS,
  FETCH_EVENTS_REQUEST, FETCH_OPERATIONS_REQUEST,
  SET_CURRENT_EVENT_ID, SET_EVENT_CURRENCY,
} from '@/store/events/types';
import {
  SET_EVENT_CONTACTS,
  SET_EVENT_SELECTED_CONTACTS,
} from '@/store/user/types';
import { SET_OPERATION_IN_ONE_CLICK } from '@/store/operations/types';
import HeaderApp from '../layouts/HeaderApp/HeaderApp';
import AddEventForm from '../forms/AddEventForm/AddEventForm';
import AddTransactionForm from '../forms/AddTransactionForm/AddTransactionForm';
import AddParticipantsForm from '../forms/AddParticipantsForm/AddParticipantsForm';
import AddEventParticipantsForm from '../forms/AddEventParticipantsForm/AddEventParticipantsForm';
import ParticipantsForm from '../forms/ParticipantsForm/ParticipantsForm';
import MoveTransactionForm from '../forms/MoveTransactionForm/MoveTransactionForm';
import PageError from '../layouts/PageError/PageError.vue';

export default {
  name: 'EventsPage',
  components: {
    MoveTransactionForm,
    ParticipantsForm,
    AddParticipantsForm,
    AddEventParticipantsForm,
    HeaderApp,
    AddEventForm,
    AddTransactionForm,
    PageError,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOptions: false,
    };
  },
  watch: {
    currentEventId(newCurrentEventId) {
      const curEvent = this.events.find((event) => (event.id === newCurrentEventId));
      if (curEvent && curEvent.event_name) {
        if (document.title.match(/\(.*\)/)) {
          document.title = document.title.replace(/\(.*\)/, `(${curEvent.event_name})`);
        } else {
          document.title += ` (${curEvent.event_name})`;
        }
      }
    },
  },
  computed: {
    ...mapState({
      finalEventSelectedContacts: (state) => state.user.finalEventSelectedContacts,
      event: (state) => state.events.event,
      events: (state) => state.events.events,
      eventsStatus: (state) => state.events.eventsStatus || '',
      currentEventId: (state) => state.events.currentEventId,
    }),
  },
  methods: {
    toggleOptionsPanel() {
      this.showOptions = !this.showOptions;
    },
    showParticipants() {
      this.$store.commit(SET_EVENT_SELECTED_CONTACTS, this.finalEventSelectedContacts);
    },
    async loadInitialEventData(eventId) {
      // const currentEventId = await this.$store.dispatch(FETCH_EVENTS_REQUEST);
      this.$store.commit(FETCH_OPERATIONS_REQUEST);
      const currentEvent = await this.$store.dispatch(FETCH_EVENTS_REQUEST);
      if (eventId) {
        try {
          this.$store.commit(SET_CURRENT_EVENT_ID, eventId);
          await this.$store.dispatch(FETCH_EVENT_REQUEST, {
            id: eventId,
            utcOffset: this.$moment().utcOffset(),
          });
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('event not found');
          await this.$router.push({ name: 'Page 404' });
        }
      } else if (currentEvent && currentEvent.id) {
        this.$store.commit(SET_CURRENT_EVENT_ID, currentEvent.id);
        this.$store.commit(FETCH_EVENT_SUCCESS, currentEvent);
        this.$store.commit(SET_EVENT_CONTACTS, currentEvent.contacts);
        this.$store.dispatch(FETCH_OPERATIONS_REQUEST, currentEvent.id);
        this.$store.dispatch(EVENT_PAYOUTS_REQUEST, {
          id: currentEvent.id,
        });
        this.$store.dispatch(FETCH_EVENT_EXPENSES_REQUEST, {
          id: currentEvent.id,
          utcOffset: this.$moment().utcOffset(),
        });
        // await this.$store.dispatch(FETCH_EVENT_REQUEST, {
        //   id: currentEventId,
        //   utcOffset: this.$moment().utcOffset(),
        // });
      } else {
        this.$store.commit(CLEAR_CURRENT_EVENT);
      }
    },
    async loadNextEvent(eventId) {
      const currentEventId = this.$store.state.events.event.id;
      const currentEventPointer = this.$store.state.events.currentEventId;
      if ((+currentEventId !== +currentEventPointer) || (+currentEventId !== +eventId)) {
        if (eventId) {
          await this.$store.dispatch(FETCH_EVENT_REQUEST, {
            id: eventId,
            utcOffset: this.$moment().utcOffset(),
            currency: this.$store.state.user.user.currency,
          });
        } else if (currentEventId) {
          const currentEvent = this.events.find((event) => event.id === currentEventId);
          this.$store.commit(FETCH_EVENT_SUCCESS, currentEvent);
          await this.$store.dispatch(FETCH_EVENT_REQUEST, {
            id: currentEventId,
            utcOffset: this.$moment().utcOffset(),
            currency: this.$store.state.user.user.currency,
          });
        }
      }
      this.nullifyEventCurrency();
    },
    nullifyEventCurrency() {
      this.$store.commit(SET_EVENT_CURRENCY, '');
    },
    hideAddTransaction() {
      this.$store.dispatch(SET_OPERATION_IN_ONE_CLICK, false);
    },
  },
  async mounted() {
    await this.loadInitialEventData(this.$route.params.id);
  },
  beforeDestroy() {
    this.nullifyEventCurrency();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id && to.params.id !== from.params.id) {
      this.loadNextEvent(to.params.id);
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.events-page {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 100%;
  flex: 1 1 100%;
}
.main {
  margin-top: 45px;
  min-height: 355px;
  height: calc(100% - 45px);
  display: flex;
  flex-direction: row;
  max-width: 100%;
}
/*.HeaderModals {*/
/*  position: relative;*/
/*animation: HeaderModals-out .3s;*/
/*}*/
/*body[class~="modal-open"] .HeaderModals {
  position: fixed;
  top: 0;
  animation: HeaderModals-in .3s;
}
@keyframes HeaderModals-in {
  0% {
    position: fixed;
    opacity: 0;
    transform: translateY(-45px);
  }
  100% {
    position: fixed;
    opacity: 1;
    transform: translateY(0);
  }
}*/
/*@keyframes HeaderModals-out {
  0% {
    position: fixed;
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    position: fixed;
    opacity: 0;
    transform: translateY(-45px);
  }
}*/
</style>
